function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "layer1",
  transform: "translate(-579.262 -1108.019)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path2654",
  d: "M618.105,1108.019a37.884,37.884,0,0,0-18.777,70.783l-20.067-.065v6.065h36v-6.775a32.686,32.686,0,1,1,4.71,0v6.775h35.811v-5.936H636.882a37.925,37.925,0,0,0-18.776-70.847ZM592.231,1132.8v26.584h5.678V1140.99l10.711,18.389h35.746V1132.8h-5.549v18.389L627.332,1132.8Zm71.879,0v26.584H708.18V1153.9h-17.1v-5.485h17.1v-5.1h-17.1v-4.969h17.1V1132.8H664.111Zm57.426,0v26.584h27.036v-10.969h17.1v-5.1h-17.1v-4.969h17.1V1132.8H721.537Zm53.361,0v26.584h27.165v-10.969h16.905v-5.033H802.062v-5.033h16.905V1132.8Z"
}));

var SvgNeff = function SvgNeff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239.705,
    height: 76.783,
    viewBox: "0 0 239.705 76.783",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNeff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/neff.fbcd5f54.svg";
export { ForwardRef as ReactComponent };